import styled from '@emotion/styled/macro';
import { TableWrapper } from '../../../../common/SideBySideTableLayout/SideBySideTableLayout.styles';
import rem from '../../../../utils/rem/rem';

export const StyledTableWrapper = styled(TableWrapper)`
  height: 60vh;
  width: 400px;
`;

export const SelectRawProdsContainer = styled.div`
  margin: 0 32px;
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: end;
  padding-top: ${rem(16)};
`;

export const Buttons = styled.div`
  display: flex;
  justify-content: space-between;
  padding-top: ${rem(16)};
`;

export const CloseButton = styled.button`
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0;
    border: none;
    background-color: transparent;
    cursor: pointer;
    font-size: ${rem(28)};
    width: ${rem(44)};
    height: ${rem(44)};
    color: ${({ theme }) => theme.colors.gray600};
    &:focus {
      outline: none;
    }
    &:focus svg {
      ${({ theme }) => theme.states.focus};
    }
`;